import {
  EVENT_TYPES,
  type BuiltInDispatchEntry
} from '@care-portals/api-interfaces';

/**
 * VSDigital's `CreateOrder` — built-in dispatch (docs/builtin-dispatch.md), same shape as TMC's.
 * Submits an order to VSDigital on `order.awaiting_shipment` without a per-org Workflow blueprint.
 */
export const VsdigitalBuiltInDispatch: BuiltInDispatchEntry[] = [
  {
    id: 'vsdigital-create-order',
    label: 'VSDigital Pharmacy — Create Order',
    triggerEvent: EVENT_TYPES.awaiting_shipment,
    triggerFilter: { 'assignedPharmacy.name': 'VSDigital Pharmacy' },
    middlewareHandler: 'vsdigital',
    functionName: 'CreateOrder',
    integrationFlag: 'isVsdigitalEnabled',
    passPayload: true
  }
];
